const labels = {
  translations: {
    navbar: {
      home: "Comienzo",
      tools: "Herramientas",
      language: "Idioma",
      social: "Social",
      articles: {
        title: "Artículos",
        article_01: {
          title:
            "Crea tu aplicación de chat por vídeo con WebRTC (Sólo en portugués)",
          url: "https://dev.to/cesarpaulomp/crie-seu-app-de-video-chat-com-webrtc-1jea",
        },
        article_02: {
          title:
            "Crea tu servidor de transmisión en vivo privado (Sólo en portugués)",
          url: "https://dev.to/cesarpaulomp/crie-seu-servidor-de-live-privado-part1-1g2g",
        },
        article_03: {
          title:
            "Generando miniaturas con NODEJS, FFMPEG, AWS Lambda y Terraform (Sólo en portugués)",
          url: "https://dev.to/cesarpaulomp/gerando-thumbnails-com-nodejs-ffmpeg-aws-lambda-e-terraform-2j00",
        },
      },
    },
    home: {
      highlights: "Destacar",
      carousel: {
        looper: {
          about: "Sepa mas",
        },
      },
      about: {
        title: `Sobre el estudio`,
        description: `Unipig es un estudio independiente que tiene como objetivo crear juegos divertidos, en diferentes dispositivos, para jugar en cualquier momento.`,
        what_is_a_unipig: `¿Qué es un "Unipig"?`,
        unipig_description: `Es una quimera muy poderosa creada por el mago Hugo, el Mayor.
        Esta criatura tiene el poder de la "irresistibilidad", lo que significa que ningún individuo vivo puede resistir su encanto.
        Y por eso, temiendo tal poder, Hugo dejó a su criatura aquí en el estudio y huyó a otro universo.`,
      },
      contact: {
        title: `¿Necesitas hablar con nosotros?`,
      },
    },
    policy: {
      title: "Política de privacidad",
    },
    game: {
      blocknator: {
        policy: {
          description:
            "Los servicios de la aplicación Blocknator son proporcionados por la persona física con el siguiente nombre: Paulo César Medeiros Porto, inscrito bajo el CPF nº 09777223684, titular de la propiedad intelectual sobre el software, sitio web, aplicaciones, contenido y demás activos relacionados con la plataforma Blocknator.",
          personal_data: "1. Datos personales y otros datos sensibles",
          personal_data_desc_01:
            "No recopilamos, almacenamos ni compartimos datos personales u otros datos sensibles que pertenezcan a quienes utilizan nuestra aplicación.",
          personal_data_desc_02:
            "No nos responsabilizamos por ningún daño generado a las personas que adquieran copias ilegales de la aplicación.",
          policy_update: "2. Cambios en esta política",
          policy_update_desc_01:
            "La presente versión de esta Política de Privacidad fue actualizada por última vez el: 11/04/2024.",
          policy_update_desc_02:
            "Nos reservamos el derecho de modificar, en cualquier momento, las presentes normas, especialmente para adaptarlas a eventuales cambios realizados en nuestra aplicación, ya sea mediante la disponibilidad de nuevas funcionalidades, ya sea mediante la supresión o modificación de aquellas ya existentes.",
          contact: "3. Cómo contactarnos",
          contact_desc_01:
            "Para aclarar cualquier duda sobre esta Política de Privacidad, póngase en contacto con el correo electrónico: ",
        },
      },
    },
  },
};
export default labels;
